// src/App.tsx
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppShell from "./components/layout/AppShell";
import CoveragePage from "./pages/CoveragePage";
import ChaptersPage from "./pages/ChaptersPage";
import CatalogPage from "./pages/CatalogPage";
import TilmidPlusConfigPage from "./pages/TilmidPlusConfigPage";
import ProvidersPage from "./pages/ProvidersPage";
import QuestReviewPage from "./pages/QuestReviewPage";
import TrialsPage from "./pages/TrialsPage";
import TrialDetailPage from "./pages/TrialDetailPage";
import ObjectiveTrialsPage from "./pages/ObjectiveTrialsPage";
import ObjectiveTrialDetailPage from "./pages/ObjectiveTrialDetailPage";
import Login from "./pages/Login";
import { RedirectIfAuthed, RequireAuth } from "./router/guard";

/** Anciennes adresses (favoris, liens partagés) → nouvel écran. */
const LEGACY_REDIRECTS: Array<[string, string]> = [
  ["/documents", "/chapters"],
  ["/programs", "/catalog"],
  ["/stages", "/catalog"],
  ["/grades", "/catalog"],
  ["/subjects", "/catalog"],
  ["/tracks", "/catalog"],
  ["/offerings", "/catalog"],
  ["/embedding-profiles", "/coverage"],
];

const App: React.FC = () => (
  <Routes>
    <Route
      path="/login"
      element={
        <RedirectIfAuthed>
          <Login />
        </RedirectIfAuthed>
      }
    />

    <Route element={<RequireAuth />}>
      <Route element={<AppShell />}>
        <Route path="/" element={<Navigate to="/coverage" replace />} />
        <Route path="/coverage" element={<CoveragePage />} />
        <Route path="/chapters" element={<ChaptersPage />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/quest-review" element={<QuestReviewPage />} />
        <Route path="/app-configs/tilmid-plus" element={<TilmidPlusConfigPage />} />
        <Route path="/llm-providers" element={<ProvidersPage />} />
        <Route path="/trials" element={<TrialsPage />} />
        <Route path="/trials/:trialId" element={<TrialDetailPage />} />
        <Route path="/objective-trials" element={<ObjectiveTrialsPage />} />
        <Route path="/objective-trials/:trialId" element={<ObjectiveTrialDetailPage />} />
        {LEGACY_REDIRECTS.map(([from, to]) => (
          <Route key={from} path={from} element={<Navigate to={to} replace />} />
        ))}
      </Route>
    </Route>

    <Route path="*" element={<Navigate to="/coverage" replace />} />
  </Routes>
);

export default App;
